import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

export const ClaroTVLogo = ({ isTV = false, onClick }) => {
  const {
    Vinculacion_Imagen_LogoClaroTV = '',
    Vinculacion_Imagen_LogoClaroVideo = '',
  } = useSelector(state => state.asset);

  return (
    <img
      className="ClaroTVLogo"
      src={
        isTV
          ? Vinculacion_Imagen_LogoClaroTV
          : Vinculacion_Imagen_LogoClaroVideo
      }
      alt="Clarovideo logo"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    />
  );
};
